<template>
  <div class="combo-page">
    <div class="combo-tab__list">
      <div v-for="item in tabMap.list" :key="item.key" :class="{ 'combo-tab__item': true, 'active': item.value === tabMap.active }" @click="onTabClick(item)">{{ item.label }}<span v-show="['inProgressCount', 'notStartedCount'].includes(item.key)">({{ item.count }})</span></div>
    </div>

    <div class="combo-content">
      <div class="combo-content__header">
        <div class="combo-content__header-item">
          <el-input
            v-model="form.keyword"
            clearable
            placeholder="活动/医生/商品"
            class="combo-search__input">
          </el-input>
        </div>
        <div class="combo-content__header-item">
          <el-select v-model="form.deptId" filterable clearable placeholder="适用门店" class="combo-search__select">
            <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId"></el-option>
          </el-select>
        </div>
        <div class="combo-content__header-item">
          <el-select v-model="form.cseType" clearable placeholder="活动类型" class="combo-search__select">
            <el-option label="套餐活动" value="1" />
            <el-option label="任选活动" value="2" />
          </el-select>
        </div>
        <div class="combo-content__header-item">
          <el-date-picker
            v-model="form.dateRange"
            type="datetimerange"
            class="combo-search__daterange"
            range-separator="至"
            start-placeholder="开始日期时间"
            end-placeholder="结束日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </div>
        <div class="combo-content__header-actions">
          <el-button type="primary" @click="search">查询</el-button>
          <el-button class="combo-btn-reset" @click="reset">重置</el-button>
        </div>
      </div>

      <div v-if="['-1', '0'].includes(deptId)" class="combo-toolbar">
        <el-button class="combo-toolbar__btn-add" icon="el-icon-plus" @click="comboEdit()">新增活动</el-button>
      </div>

      <div class="combo-table-wrap">
        <el-table
          :data="dataMap.list"
          border
          class="combo-table">
          <el-table-column prop="cseCode" label="活动ID" min-width="180" align="center"></el-table-column>
          <el-table-column prop="cseName" label="活动名称" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column label="活动类型" width="80" align="center">
            <template slot-scope="{ row }">
              <div class="combo-table-type-wrap">
                <div :class="['combo-table-type', campaignTypeFilter(row.cseType).class]">{{ campaignTypeFilter(row.cseType).text }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="适用门店" prop="deptNames" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column label="适用医生" prop="doctorNames" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column label="活动金额(元)" prop="price" min-width="110" align="right"></el-table-column>
          <el-table-column label="活动状态" width="100" align="center">
            <template slot-scope="{ row }">
              <span :class="['combo-status', campaignStatusFilter(row.status).class]">{{ row.statusName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="timeRange" label="活动时间" min-width="300">
            <template slot-scope="{ row }">
              <span>{{ row.startTime }} - {{ row.endTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="更新人" prop="updateByName" min-width="100" align="center"></el-table-column>
          <el-table-column label="更新时间" prop="updateTime" min-width="160" align="center"></el-table-column>
          <el-table-column label="操作" width="130" fixed="right" align="left">
            <template slot-scope="{ row }">
              <div class="combo-table__actions">
                <div class="combo-link combo-link--primary" @click="comboEdit('view', row.cseCode)">查看</div>
                <div v-if="['-1', '0'].includes(deptId) && [0, 1].includes(row.status)" class="combo-link combo-link--primary" @click="comboEdit('edit', row.cseCode)">修改</div>
                <el-popconfirm
                  v-if="['-1', '0'].includes(deptId) && [0].includes(row.status)"
                  title="删除后活动将无法恢复，是否确认删除？"
                  confirm-button-type="danger"
                  @confirm="comboDelete(row)">
                  <div class="combo-link combo-link--danger" slot="reference">删除</div>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="combo-table__pagination">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="dataMap.pageNo"
            :page-size="dataMap.pageSize"
            :total="dataMap.total"
            @current-change="pageNoChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <ComboEdit ref="comboEdit" @success="comboEditSuccess"></ComboEdit>
  </div>
</template>

<script>
import { getComboDeptList, getComboStatusCount, getComboSaleList, deleteCombSale } from "@/api/campaign";
import ComboEdit from '../components/ComboEdit.vue'
export default {
  name: 'combo',
  components: {
    ComboEdit
  },
  data() {
    return {
      deptId: sessionStorage.getItem('deptId') || '',
      tabMap: {
        active: '',
        list: [
          { key: 'totalCount', label: '全部', value: '', count: 0 },
          { key: 'inProgressCount', label: '进行中', value: '1', count: 0 },
          { key: 'notStartedCount', label: '未开始', value: '0', count: 0 },
          { key: 'endedCount', label: '已结束', value: '2', count: 0 }
        ]
      },
      deptList: [],
      form: {
        keyword: '',
        deptId: '',
        cseType: '',
        dateRange: null
      },
      dataMap: {
        list: [],
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created () {
    this.getComboDeptList()
    this.getStatusCount()
    this.getComboList()
  },
  methods: {
    async getComboDeptList () {
      const res = await getComboDeptList({
        pageNo: 1,
        pageSize: 1000
      })
      if (res.code === 200) {
        this.deptList = res.data && res.data.list || []
      }
    },
    async getStatusCount () {
      const res = await getComboStatusCount()
      if (res.code === 200) {
        this.tabMap.list.map(item => {
          item.count = res.data && res.data[item.key] || 0
        })
      }
    },
    async getComboList () {
      const res = await getComboSaleList({
        status: this.tabMap.active,
        keyword: this.form.keyword,
        deptIds: this.form.deptId ? [this.form.deptId] : '',
        cseType: this.form.cseType,
        startTime: this.form.dateRange && this.form.dateRange[0] || '',
        endTime: this.form.dateRange && this.form.dateRange[1] || '',
        pageNo: this.dataMap.pageNo,
        pageSize: this.dataMap.pageSize
      })
      if (res.code === 200) {
        this.dataMap.list = res.data && res.data.list || []
        this.dataMap.total = res.data && res.data.total || 0
      }
    },
    pageNoChange (pageNo) {
      this.dataMap.pageNo = pageNo
      this.getComboList()
    },
    campaignTypeFilter (type) {
      const typeMap = {
        1: { text: '套餐', class: 'combo' },
        2: { text: '任选', class: 'optional' }
      }
      return typeMap[type] || { text: '', class: '' }
    },
    campaignStatusFilter (status) {
      const statusMap = {
        1: { text: '进行中', class: 'is-running' },
        0: { text: '未开始', class: 'is-pending' },
        2: { text: '已结束', class: 'is-ended' }
      }
      return statusMap[status] || { text: '', class: '' }
    },
    onTabClick (item) {
      this.tabMap.active = item.value

      this.getStatusCount()

      this.dataMap.pageNo = 1
      this.getComboList()
    },
    search () {
      this.getStatusCount()

      this.dataMap.pageNo = 1
      this.getComboList()
    },
    reset () {
      this.getStatusCount()

      this.form.keyword = ''
      this.form.deptId = ''
      this.form.cseType = ''
      this.form.dateRange = null
      this.dataMap.pageNo = 1
      this.getComboList()
    },
    comboEdit (type = 'add', code = '') {
      this.$refs.comboEdit.open(type, code)
    },
    comboEditSuccess () {
      this.getStatusCount()
      this.getComboList()
    },
    async comboDelete(row) {
      const res = await deleteCombSale({ cseCode: row.cseCode })
      if (res.code === 200) {
        this.$message.success('删除成功')
        this.getStatusCount()
        this.getComboList()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.combo-page {
  box-sizing: border-box;
  height: 100%;
  background: #FFFFFF;
  overflow: hidden;
}

.combo-tab__list {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 24px;
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #E0E0E0;
}

.combo-tab__item {
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 600;
  font-size: 16px;
  color: #667182;
  cursor: pointer;
}

.combo-tab__item + .combo-tab__item {
  margin: 0 0 0 32px;
}

.combo-tab__item.active {
  color: #000000;
}

.combo-tab__item.active::after {
  content: '';
  position: absolute;
  z-index: 2;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #1890FF;
  border-radius: 4px;
}

.combo-content {
  box-sizing: border-box;
  padding: 24px;
  width: 100%;
  height: calc(100% - 60px);
  overflow-x: hidden;
  overflow-y: auto;
}

.combo-content__header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 16px;
  width: 100%;
}

.combo-content__header-item + .combo-content__header-item {
  margin: 0 0 0 16px;
}

.combo-content__header-actions {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 0 0 16px;
}

.combo-search__input {
  width: 200px;
}

.combo-search__select {
  width: 200px;
}

.combo-search__daterange {
  width: 360px;
}

.combo-search__daterange /deep/ .el-range__close-icon{
  line-height: 25px;
}

.combo-content__header-actions /deep/ .el-button + .el-button {
  margin-left: 8px;
}

.combo-btn-reset {
  background: #fff;
  border-color: #D3D3D5;
  color: #1F2329;
}

.combo-toolbar {
  margin: 24px 0 0 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.combo-toolbar__btn-add {
  color: #FFFFFF;
  background-color: #29C01B;
  border: none;
}

.combo-table-wrap {
  margin: 16px 0 0 0;
  width: 100%;
}

.combo-table {
  
}

.combo-table /deep/ th.el-table__cell {
  color: #667182;
  background-color: #F7F8F9;
}

.combo-table-type-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.combo-table-type {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  width: fit-content;
  height: 26px;
  font-size: 12px;
  border-radius: 4px;
}

.combo-table-type.combo {
  color: #1890FF;
  background-color: #E8F4FF;
}

.combo-table-type.optional {
  color: #29C01B;
  background-color: #E2F8E0;
}

.combo-status.is-running {
  color: #67c23a;
}

.combo-status.is-pending {
  color: #409eff;
}

.combo-status.is-ended {
  color: #909399;
}

.combo-table__actions {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.combo-link {
  margin: 0 8px 0 0;
  font-size: 14px;
  cursor: pointer;
}

.combo-link--primary {
  color: #1890FF;
}

.combo-link--danger {
  color: #F54A45 ;
}

.combo-table__pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 12px 0 0 0;
  width: 100%;
}
</style>
